export { default, SkillLevelScale } from './SkillLevelScale';